import React from 'react';
import AppRoute from './AppRoute';
import { authenticatedHOC } from '../HOC';
import ModelList from '../Pages/ModelList';
import Inference from '../Pages/Inference';
import RuntimeHistory from '../Pages/RuntimeHistory';
import ModelArchive from '../Pages/ModelArchive';
import Administration from '../Pages/Administration';

/** --------  ** * Add private routes here (which requires auth) * **   ---------*/
const privateRoutesList = [
  {
    component: ModelList,
    asyncReducerNames: ['modelListReducer'],
    path: '/model-list',
    exact: true,
  },
  {
    component: Inference,
    asyncReducerNames: ['inferenceReducer'],
    path: '/model-list/:modelId/inference/:inferenceId',
    exact: true,
  },
  {
    component: RuntimeHistory,
    asyncReducerNames: ['runtimeHistoryReducer'],
    path: '/model-list/:modelId/runtime-history',
    exact: true,
  },
  {
    component: ModelArchive,
    asyncReducerNames: ['modelArchiveReducer'],
    path: '/model-archive',
    exact: true,
  },
  {
    component: Administration,
    asyncReducerNames: ['administrationReducer'],
    path: '/administration',
    exact: true,
  },
];

const PrivateRoutes = () =>
  privateRoutesList.map((routeObject, index) => (
    <AppRoute {...routeObject} authNoAuthHOC={authenticatedHOC} key={index} />
  )) || [];

export default PrivateRoutes;
